/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getUserInfoAsync } from './ContactActions/DataActionExtension.g';
import { IGetUserInfoResponse } from './ContactActions/DataServiceEntities.g';

/**
 * GetUserInfo Input Action
 */
export class GetUserInfoInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `USERINFO`;
    public getCacheObjectType = () => 'USERINFO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetUserInfoInput();
};

async function action(input: GetUserInfoInput, ctx: Msdyn365.IActionContext): Promise<IGetUserInfoResponse> {
    const info = await getUserInfoAsync({ callerContext: ctx });
    return info;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetUserInfoResponse>>action,
    id: 'GetUserInfo',
    input: createInput
});
